module.exports = {
    ADMIN: { description: 'Admin', code: 1 },
    REGULAR: { description: 'Regular', code: 2 },
}
